export const GET_PROPERTIES_STARTED = "GET_PROPERTIES_STARTED";
export const GET_PROPERTIES_SUCCESS = "GET_PROPERTIES_SUCCESS";
export const GET_PROPERTIES_FAILED = "GET_PROPERTIES_FAILED";
